<template>
    <v-content :style="{'background-image': `url('`+ require('../assets/bg-login.jpg') +`')`}"
               style="background-size: cover">
        <v-layout justify-center class="reset-password-form" mb-12>
            <v-flex xs12 sm9 md4 mb-12>
                <v-card class="pa-5 mt-12 reset-password-card border-bottom-form">
                    <v-container>
                        <v-layout justify-center>
                            <v-flex xs4>
                                <img alt="Vue logo" src="../assets/logo.png" style="width: 100%">
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex class="pt-12 pb-8">
                                <h3>Enter your new password below</h3>
                            </v-flex>
                        </v-layout>
                        <v-layout pt-3 justify-center>
                            <v-flex xs3 mx-3 pt-1 style="text-align: right;">
                                <span style="font-weight: bold; color: #527281">Email :</span>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                        hide-details
                                        readonly
                                        dark
                                        v-model="email"
                                        background-color="#527281"
                                        placeholder="www.gmail.coom"
                                        solo
                                        Dense
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout pt-3 justify-center>
                            <v-flex xs3 mx-3 pt-1 style="text-align: right;">
                                <span style="font-weight: bold; color: #527281">Password :</span>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                        hide-details
                                        dark
                                        type="password"
                                        v-model="password"
                                        background-color="#527281"
                                        solo
                                        Dense
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout pt-3 justify-center>
                            <v-flex xs3 mx-3 pt-1 style="text-align: right;">
                                <span style="font-weight: bold; color: #527281">Confirm Password :</span>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                        hide-details
                                        dark
                                        type="password"
                                        v-model="password_confirmation"
                                        background-color="#527281"
                                        solo
                                        Dense
                                        required
                                ></v-text-field>
                            </v-flex>
                            <v-spacer></v-spacer>
                        </v-layout>

                        <v-layout justify-center pt-8>
                            <v-flex class="shrink">
                                <v-btn
                                        style="border-radius: 30px; background-color: #527281; color: #fff"
                                        class="ma-2 xs6 md6"
                                        @click="resetPassword"
                                >
                                    Reset Password
                                </v-btn>
                            </v-flex>
                            <v-flex class="shrink">
                                <v-btn
                                        style="border-radius: 30px; background-color: gray; color: #fff"
                                        class="ma-2 xs6 md6"
                                        @click="$router.push('/').catch(err => {})"
                                >
                                    ย้อนกลับ
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-container>


                </v-card>
            </v-flex>
        </v-layout>

        <loading
                color="#527281"
                :active.sync="isLoading"
                :can-cancel="false"
                :is-full-page="fullPage"
        ></loading>

        <Footer></Footer>
    </v-content>
</template>


<script>
    import Footer from '@/components/Footer.vue';
    import Swal from 'sweetalert2'
    import Loading from 'vue-loading-overlay';

    export default {
        name: "ResetPasswordForm",
        components: {
            Footer,
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                token: null,
                email: null,
                password: null,
                password_confirmation: null,
            }
        },
        created() {
          this.getEmailFromToken();
        },
        methods: {
            resetPassword() {
                this.isLoading = true;
                this.$store.dispatch('Auth/resetPassword', {
                    token: this.$route.params.token,
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password_confirmation
                }).then(res => {
                    Swal.fire({
                        title: res.message,
                        confirmButtonColor: '#527281',
                        showClass: {
                            popup: 'animated fadeInDown faster'
                        },
                        hideClass: {
                            popup: 'animated fadeOutUp faster'
                        }
                    }).then((result) => {
                        this.isLoading = false;
                        this.$router.push({name: 'login'})
                    })
                }, error => {
                    this.isLoading = false;
                    Swal.fire({
                        icon: 'error',
                        title: error.response.statusText +" "+ error.response.status,
                        text: error.response.data.message,
                        confirmButtonColor: '#527281',
                    }).then((result) => {
                        this.isLoading = false;
                    })
                })
            },
            getEmailFromToken() {
                this.isLoading = true;
                this.$store.dispatch('Auth/getEmailFromToken',{token:this.$route.params.token}).then(res => {
                    this.email = res.email;
                    this.isLoading = false;
                }).catch(e => {
                    Swal.fire({
                        icon: 'error',
                        title: 'This password reset token is invalid.',
                        text: "กรุณากดขอ Link reset password อีกครั้ง!"
                    }).then((result) => {
                        this.$router.push({name: 'login'})
                        this.isLoading = false;
                    })
                })
            }
        }

    }
</script>

<style lang="scss">
     .reset-password-form {
         .reset-password-card {
             background: rgba(255,255,255,.18) !important;
         }
         .border-top-form {
             border-top-left-radius: 20px;
             border-top-right-radius: 20px;
         }
         .border-bottom-form {
             border-top-left-radius: 20px;
             border-top-right-radius: 20px;
             border-bottom-left-radius: 20px;
             border-bottom-right-radius: 20px;
         }
         .v-text-field.v-text-field--solo .v-input__control {
             min-height: 35px !important;
         }
     }
</style>
